import { useRef, useState } from 'react'
import { useAnalytics } from '@/analytics/hooks/useAnalytics'
import { TableDocumentSource } from '@/analytics/enums/table.enums'
import { trackTableDocumentsAdded } from '@/analytics/utils/table-analytics'
import { useDispatch } from 'react-redux'
import { AnalysisActions } from '../analysis/store/slice'
import { postAddTableDocuments } from '../fetch/post-add-table-documents'

export function useAddTableDocuments(matterId: string, tableId: string, onAdded: () => void, onSettled: () => void) {
  const dispatch = useDispatch()
  const { trackEvent } = useAnalytics()
  const [addingDocuments, setAddingDocuments] = useState(false)
  const [addDocumentsError, setAddDocumentsError] = useState<string | null>(null)
  const inFlight = useRef(false)
  const addDocuments = async (documentIds: string[]) => {
    if (inFlight.current) return false
    if (!documentIds.length) return true
    inFlight.current = true
    setAddingDocuments(true)
    setAddDocumentsError(null)
    try {
      const run = await postAddTableDocuments(matterId, tableId, documentIds)
      trackTableDocumentsAdded(trackEvent, tableId, documentIds.length, TableDocumentSource.ExistingMatterFiles)
      dispatch(AnalysisActions.refresh(tableId))
      dispatch(AnalysisActions.received({ tableId, run }))
      onAdded()
      return true
    } catch (reason) {
      setAddDocumentsError(reason instanceof Error ? reason.message : 'Unable to add documents.')
      return false
    } finally {
      inFlight.current = false
      setAddingDocuments(false)
      onSettled()
    }
  }
  return { addingDocuments, addDocumentsError, addDocuments, clearError: () => setAddDocumentsError(null) }
}
